import React from "react";
import "../../App.css";
import { Link } from "react-router-dom";

import EmissionHeader from "../../components/emissions/EmissionHeader";
import EmissionTravelSection from "../../components/emissions/EmissionTravelSection";
import EmissionHotelSection from "../../components/emissions/EmissionHotelSection";
import EmissionQuestionsSection from "../../components/emissions/EmissionQuestionsSection";
import EmissionActionsCard from "../../components/emissions/EmissionActionsCard";
import useEmissionForm from "../../hooks/useEmissionForm";
import { useLanguage } from "../../context/LanguageContext";

function Emission() {
  const { language } = useLanguage();
  const {
    airTravel,
    setAirTravel,
    travelTime,
    setTravelTime,
    eventTransport,
    setEventTransport,
    kmLand,
    setKmLand,
    stayedInHotelFlag,
    setStayedInHotelFlag,
    hotelNights,
    setHotelNights,
    isHotelYes,
    questionsEmissions1,
    setQuestionsEmissions1,
    questionsEmissions2,
    setQuestionsEmissions2,
    questionsEmissions3,
    setQuestionsEmissions3,
    formErrors,
    requiresScope,
    isSubmitting,
    setStoredValue,
    btnBack,
    btnNext,
    eventTransports,
  } = useEmissionForm(language);

  return (
    <div className="container">
      <EmissionHeader language={language} />

      <form onSubmit={btnNext}>
        <EmissionTravelSection
          language={language}
          airTravel={airTravel}
          setAirTravel={setAirTravel}
          travelTime={travelTime}
          setTravelTime={setTravelTime}
          eventTransport={eventTransport}
          setEventTransport={setEventTransport}
          kmLand={kmLand}
          setKmLand={setKmLand}
          setStoredValue={setStoredValue}
          formErrors={formErrors}
          eventTransports={eventTransports}
        />

        <EmissionHotelSection
          language={language}
          stayedInHotelFlag={stayedInHotelFlag}
          setStayedInHotelFlag={setStayedInHotelFlag}
          hotelNights={hotelNights}
          setHotelNights={setHotelNights}
          isHotelYes={isHotelYes}
          setStoredValue={setStoredValue}
          formErrors={formErrors}
        />

        <EmissionQuestionsSection
          language={language}
          questionsEmissions1={questionsEmissions1}
          setQuestionsEmissions1={setQuestionsEmissions1}
          questionsEmissions2={questionsEmissions2}
          setQuestionsEmissions2={setQuestionsEmissions2}
          questionsEmissions3={questionsEmissions3}
          setQuestionsEmissions3={setQuestionsEmissions3}
          requiresScope={requiresScope}
          setStoredValue={setStoredValue}
          formErrors={formErrors}
        />

        <div>
          <p className="legal">
            {language === "EN" ? "*Required fields" : "*Los campos son requeridos"}
          </p>
        </div>

        <EmissionActionsCard
          language={language}
          btnBack={btnBack}
          isSubmitting={isSubmitting}
        />

        <h4 className="footerCopyright">
          {language === "EN"
            ? "Design, code, words, and hard work by "
            : "Design, code, words, and hard work by "}
          <Link to="https://wcm.media" target="_blank">
            Wildcat Media.
          </Link>
        </h4>
      </form>
    </div>
  );
}

export default Emission;
